import { Routes } from '@angular/router'

import { AuthenticatedLayoutComponent } from './layouts/authenticated-layout/authenticated-layout.component'
import { authGuard } from './pages/login/guards/auth.guard'
import { demoAccountGuard } from './pages/login/guards/demo-account.guard'
import { TabsPage } from './pages/tabs/tabs.page'
import { twoFactorAuthGuard } from './pages/two-factor-auth/guards/two-factor-auth.guard'

export const routes: Routes = [
	{
		path: 'login',
		loadComponent: () => import('./pages/login/login.page').then((module) => module.LoginPage),
	},
	{
		path: 'two-factor-auth/:step',
		canActivate: [twoFactorAuthGuard, demoAccountGuard],
		loadComponent: () => import('./pages/two-factor-auth/two-factor-auth.page').then((m) => m.TwoFactorAuthPage),
	},
	{
		path: 'disclaimer',
		loadComponent: () => import('./shared/components/disclaimer/disclaimer.component').then((module) => module.DisclaimerComponent),
	},
	{
		path: 'maintenance',
		loadComponent: () => import('./pages/maintenance/maintenance.component').then((module) => module.MaintenanceComponent),
	},
	{
		path: '',
		component: AuthenticatedLayoutComponent,
		canActivate: [authGuard],
		children: [
			{
				path: '',
				component: TabsPage,
				children: [
					{
						path: 'home',
						loadComponent: () => import('./pages/home/home.page').then((m) => m.HomePage),
					},
					{
						path: 'my-markets',
						loadComponent: () => import('./pages/my-markets/my-markets.page').then((m) => m.MyMarketsPage),
					},
					{
						path: 'my-bets',
						loadComponent: () => import('./pages/my-bets/my-bets.page').then((m) => m.MyBetsPage),
					},
					{
						path: 'sports',
						loadComponent: () => import('./pages/sports/sports.page').then((m) => m.SportsPage),
					},
					{
						path: 'event-list/:competitionId',
						loadComponent: () => import('./pages/event-list/event-list.page').then((m) => m.EventListPage),
					},
					{
						path: 'market/:marketId',
						loadComponent: () => import('./pages/event-detail/event-detail.page').then((m) => m.EventDetailPage),
					},
					{
						path: 'event/:eventId',
						loadComponent: () => import('./pages/event-detail/event-detail.page').then((m) => m.EventDetailPage),
					},
					{
						path: '',
						redirectTo: '/home',
						pathMatch: 'full',
					},
				],
			},
			{
				path: 'my-profile',
				canActivate: [demoAccountGuard],
				loadComponent: () => import('./pages/my-profile/my-profile.page').then((m) => m.MyProfilePage),
			},
			{
				path: 'past-bets',
				loadComponent: () => import('./pages/past-bets/past-bets.page').then((m) => m.PastBetsPage),
			},
			{
				path: 'account-statement',
				loadComponent: () => import('./pages/account-statement/account-statement.page').then((m) => m.AccountStatementPage),
			},
			{
				path: 'profit-and-loss',
				loadComponent: () => import('./pages/profit-and-loss/profit-and-loss.page').then((m) => m.ProfitAndLossPage),
			},
			{
				path: 'change-password',
				canActivate: [demoAccountGuard],
				loadComponent: () => import('./pages/change-password/change-password.page').then((m) => m.ChangePasswordPage),
			},
			{
				path: 'bet-slip-settings',
				loadComponent: () => import('./pages/bet-slip-settings/bet-slip-settings.page').then((m) => m.BetSlipSettingsPage),
			},
			{
				path: 'wallet-transfer',
				loadComponent: () => import('./pages/wallet-transfer/wallet-transfer.page').then((m) => m.WalletTransferPage),
			},
		],
	},
	{
		path: '**',
		redirectTo: '/home',
		pathMatch: 'full',
	},
]
